import { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

export default function RouteScrollManager() {
  const location = useLocation();

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useLayoutEffect(() => {
    const hashId = decodeURIComponent(location.hash.replace(/^#/, ""));
    const timers = [];

    if (!hashId) {
      const scrollToTop = () =>
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });

      scrollToTop();
      [50, 200, 500].forEach((delay) => {
        timers.push(window.setTimeout(scrollToTop, delay));
      });

      return () => timers.forEach(window.clearTimeout);
    }

    const scrollToHash = () => {
      const target = document.getElementById(hashId);
      if (target) target.scrollIntoView({ block: "start", behavior: "auto" });
    };

    scrollToHash();
    [50, 200, 500, 1000, 1600].forEach((delay) => {
      timers.push(window.setTimeout(scrollToHash, delay));
    });

    return () => timers.forEach(window.clearTimeout);
  }, [location.pathname, location.search, location.hash]);

  return null;
}
